import * as React from 'react'
import styles from './notificationCount-style.css'
type Props = {
  notificationCount: string
}

function NotificationCount({ notificationCount }: Props) {
  if (!notificationCount) return null
  return <span className={styles.notificationCount}>{notificationCount}</span>
}

NotificationCount.displayName = 'NotificationCount'
NotificationCount.defaultProps = {}
export default NotificationCount